import { clientLogos } from "@/mocks/serra";

export default function LogosMarquee() {
  return (
    <section className="relative bg-bg py-16 border-y border-white/5 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 text-center mb-10">
        <span className="text-cyan text-xs font-mono-tech tracking-[0.2em] uppercase block">
          Quem confia na Serra Consultoria
        </span>
      </div>

      <div className="relative">
        <div className="absolute inset-y-0 left-0 w-24 lg:w-48 bg-gradient-to-r from-bg to-transparent z-10 pointer-events-none"></div>
        <div className="absolute inset-y-0 right-0 w-24 lg:w-48 bg-gradient-to-l from-bg to-transparent z-10 pointer-events-none"></div>

        <div className="flex gap-8 w-max animate-marquee [animation-duration:48s] hover:[animation-play-state:paused]">
          {[...clientLogos, ...clientLogos].map((client, i) => (
            <div
              key={`${client.name}-${i}`}
              className="w-56 h-36 flex-shrink-0 rounded-2xl bg-white/95 flex items-center justify-center p-8 overflow-hidden"
            >
              <img
                src={client.image}
                alt={client.name}
                className={`max-w-full max-h-full object-contain grayscale opacity-60 hover:grayscale-0 hover:opacity-100 hover:scale-125 transition-all duration-500 ${
                  client.invert ? "invert" : ""
                }`}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
